import $ from 'jquery'
import 'modernizr'

const TYPES = {
    'object-fit-fill': {
        'background-size': '100% 100%',
        'color': 'rgba(0, 0, 0, 0)',
    },
    'object-fit-contain': {
        'background-size': 'contain',
        'background-position': 'center center',
        'background-repeat': 'no-repeat',
        'color': 'rgba(0, 0, 0, 0)',
    },
    'object-fit-cover': {
        'background-size': 'cover',
        'background-position': 'center center',
        'color': 'rgba(0, 0, 0, 0)',
    },
}

export default () => {
    if (!Modernizr.objectfit) {
        setObjectFitFallback();
    }
}

function setObjectFitFallback () {
    $('img').each((index, value) => {
        let img = $(value)
        let type = null

        $.each(TYPES, (index, value) => {
            if (img.hasClass(index)) {
                type = index
            }
        })

        if (type == null) {
            return
        }

        img.css($.extend(
            {'background-image': 'url(' + img.attr('src') + ')'},
            TYPES[type]
        )).removeAttr('src')
    })
}
